import { axiosClient } from "auth-sdk";
import type { AxiosResponse } from "axios";

import type { UnderwritingDecisionResponse } from "../schemas";

export const getUnderwritingDecision = (customerDomain: string) => {
  const requestPath = `/${customerDomain}/financing/underwriting/decision-status`;

  return {
    queryKey: ["getUnderwritingDecision"],
    queryFn: () => axiosClient.get<UnderwritingDecisionResponse>(requestPath),
    select: ({ data }: AxiosResponse<UnderwritingDecisionResponse>) => data,
  };
};
